var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowDownSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-chevron-down-2",
    "data-name": "icon-chevron-down",
    transform: "translate(28) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    width: 28,
    height: 28,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL1_wght400_GRAD0_opsz24",
    d: "M.321,12.688a1.2,1.2,0,0,1,0-1.633L4.871,6.5.321,1.954A1.106,1.106,0,0,1,0,1.138,1.1,1.1,0,0,1,1.138,0a1.106,1.106,0,0,1,.817.321L7.321,5.687a1.03,1.03,0,0,1,.249.379,1.359,1.359,0,0,1,0,.875,1.03,1.03,0,0,1-.249.379L1.954,12.688a1.106,1.106,0,0,1-.817.321,1.106,1.106,0,0,1-.817-.321Z",
    transform: "translate(10.92 7.496)",
    fill: "#222227"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownSquare);
export default __webpack_public_path__ + "static/media/icon-arrow-down-square.e2e92203f75a70e66457d810464b8de6.svg";
export { ForwardRef as ReactComponent };